import { useAnalyticsImpressions } from 'analytics/contexts/AnalyticsImpressionsProvider'
import { useEECEvents } from 'analytics/hooks/useEECEvents/useEECEvents'
import type { Item } from 'analytics/utils/getEECItems/getEECItems'
import { Breakpoints } from 'fukku/styles/breakpoints'
import { useIntersectionObserver } from 'hooks/useIntersectionObserver/useIntersectionObserver'
import Image from 'next/image'
import { useEffect, useRef } from 'react'
import { ClientLink } from 'utils/link/client'
import { ANALYTICS_LIST_ID } from '../../../../constants/constants'
import type { RecommendedProduct } from '../../../../types/messageTypes'
import styles from './FashionAssistantProduct.module.scss'
interface FashionAssistantProductProps {
	readonly product: RecommendedProduct
}
const IMPRESSION_THRESHOLD = 0.5

export function FashionAssistantProduct({
	product,
}: FashionAssistantProductProps) {
	const productImageRef = useRef<HTMLImageElement | null>(null)
	const entry = useIntersectionObserver(productImageRef, {
		threshold: IMPRESSION_THRESHOLD,
		freezeOnceVisible: true,
	})
	const { sendSelectItem } = useEECEvents()
	const { addImpression } = useAnalyticsImpressions()

	const onProductClick = () => {
		const item: Item = {
			productId: product.id,
			colorId: product.colorId,
			listId: ANALYTICS_LIST_ID,
			quantity: 1,
		}
		sendSelectItem({ item })
	}

	useEffect(() => {
		if (entry?.isIntersecting) {
			const item: Item = {
				productId: product.id,
				colorId: product.colorId,
				listId: ANALYTICS_LIST_ID,
				quantity: 1,
			}
			addImpression(item)
		}
	}, [entry?.isIntersecting])

	return (
		<ClientLink
			key={product.name}
			className={styles.fashionAssistantProduct}
			href={product.url}
			onClick={onProductClick}
		>
			<Image
				src={product.image}
				alt={product.name}
				fill
				priority
				sizes={`(min-width: ${Breakpoints.large}px) calc(412px/3), calc(412px/3)`}
				ref={productImageRef}
			/>
		</ClientLink>
	)
}
